import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "src/hooks/useAuth";
import { 
  checkRouteAccess, 
  isPublicRoute,
  getAccessibleRoutes
} from "src/utils/routePermissions";
import FallbackSpinner from "src/@core/components/spinner";

const ProtectedRoute = ({ children }) => {
  const { user, givenPermission, loading, permissionsLoading } = useAuth();
  const location = useLocation();

  // Show loading spinner while auth or permissions are being loaded
  if (loading || permissionsLoading) {
    return <FallbackSpinner />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const currentPath = location.pathname;
  
  // Check if it's a public authenticated route
  if (isPublicRoute(currentPath)) {
    return children;
  }

  // Allow access to all routes for authenticated users (no role-based restrictions)
  return children;
};

export { getAccessibleRoutes };
export default ProtectedRoute; 